// 2P AI — bottone icona (piastrella) della command bar.
import { Icon } from './Icon';

export function IconButton({ icon, label, onClick }: { icon: string; label: string; onClick?: () => void }) {
  return (
    <button className="iconbtn" type="button" onClick={onClick} title={label} aria-label={label}>
      <Icon name={icon} />
    </button>
  );
}
